// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-thread-module__wrapper--3Mcb9{box-sizing:border-box;border-left:1px dashed #afafaf;padding-left:15px}.comment-thread-module__threadNode--1EjlR{margin-top:30px}.comment-thread-module__threadNode--1EjlR>div:not(:first-child)>div{padding-top:30px}", ""]);
// Exports
exports.locals = {
	"wrapper": "comment-thread-module__wrapper--3Mcb9",
	"threadNode": "comment-thread-module__threadNode--1EjlR"
};
module.exports = exports;
